import { LandingHeader } from "@/components/landing/LandingHeader";
import { HeroSection } from "@/components/landing/HeroSection";
import { HumanFactorSection } from "@/components/landing/HumanFactorSection";
import { AICFOSection } from "@/components/landing/AICFOSection";
import { FeaturesSection } from "@/components/landing/FeaturesSection";
import { HowItWorksSection } from "@/components/landing/HowItWorksSection";
import { WhoItsForSection } from "@/components/landing/WhoItsForSection";
import { TestimonialsSection } from "@/components/landing/TestimonialsSection";
import { FAQSection } from "@/components/landing/FAQSection";
import { CTASection } from "@/components/landing/CTASection";
import { LandingFooter } from "@/components/landing/LandingFooter";
import { SEOHead } from "@/components/seo/SEOHead";
import { organizationSchema, webSiteSchema } from "@/components/seo/structured-data";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { checkUserRole } from "@/lib/userUtils";

export default function LandingPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const hashParams = new URLSearchParams(window.location.hash?.slice(1) || "");
    if (hashParams.get("error") === "access_denied" && hashParams.get("error_code") === "otp_expired") {
      window.history.replaceState(null, "", window.location.pathname + window.location.search);
      navigate("/auth?reset_error=expired", { replace: true });
      return;
    }

    supabase.auth.getSession().then(async ({ data: { session } }) => {
      if (session?.user) {
        const isGlobalAdmin = await checkUserRole('global_admin');
        
        if (isGlobalAdmin) {
          navigate("/dashboard");
          return;
        }

        const { data: profile } = await supabase
          .from("profiles")
          .select("company_id")
          .eq("user_id", session.user.id)
          .single();

        if (profile?.company_id) {
          navigate("/dashboard");
        } else {
          navigate("/onboarding");
        }
      }
    });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Dollar Bill — Clarity for Every Dollar"
        description="Financial clarity for small food businesses. Weekly P&Ls, automated invoice parsing, menu profitability, and a CFO you can ask anything. Stop guessing. Start knowing."
        canonical="/"
        keywords="restaurant financial management, food truck accounting, weekly P&L, menu profitability, AI CFO, food business accounting, small restaurant software"
        structuredData={[organizationSchema(), webSiteSchema()]}
      />
      <LandingHeader />
      <main>
        <HeroSection />
        <WhoItsForSection />
        <HumanFactorSection />
        <AICFOSection />
        <FeaturesSection />
        <HowItWorksSection />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
      </main>
      <LandingFooter />
    </div>
  );
}
